<template>
  <FocusLock>
    <slo-configure :filters="`(mid:${mid})`" />
    <ais-hits :transform-items="transformItems">
      <template v-slot="{ items }">
        <div class="slide-container fixed pin flex flex-col bg-black md:flex-row">
          <div class="slide relative px-lg md:w-2/3" :class="{ open: !!isSidebarOpen }">
            <a
              @click.prevent="handleClose"
              class="cursor-pointer p-0 absolute mt-md mr-lg c-white md:mt-xl md:pb-3xl"
              style="right: 0"
            >
              <SloIcon name="XMark" class="c-white" />
            </a>
            <div
              class="mx-auto"
              :style="'max-width:' + (isSidebarOpen ? '900px' : '1120px') + ';'"
            >
              <div
                v-if="items[0]"
                class="flex flex-col mt-2xl -mx-lg md:mt-4xl md:mx-0"
              >
                <figure class="responsive-image ratio ratio-7/5 bg-gray-200">
                  <img v-if="!loading" class="object-cover" :src="items[0].image_url" :alt="items[0].name" />
                </figure>
                <div
                  class="items-center justify-between mt-lg text-center md:mt-sm md:flex"
                >
                  <h3 class="c-white text-lg">
                    {{ items[0].name }}
                  </h3>
                  <div class="md:flex items-center">
                    <span class="hidden mr-md c-gray-700 md:block">
                      {{ items[0].width }} x {{ items[0].height }}px
                    </span>
                    <slo-button
                      :href="items[0].image_url"
                      download
                      fill="solid mt-md md:mt-0"
                      color="white"
                    >
                      {{ 'Download' | t }}
                      <SloIcon name="ArrowDownToLine" class="ml-xs" />
                    </slo-button>
                  </div>
                </div>
                <Tags :item="item" />
              </div>
            </div>
          </div>
          <Sidebar
            :state="productDetailsState"
            :products="products"
            @toggled="handleToggle"
            :class="{ open: !!isSidebarOpen }"
          />
        </div>
      </template>
    </ais-hits>
  </FocusLock>
</template>

<script>
import FocusLock from 'vue-focus-lock';
import Sidebar from './Sidebar.vue';
import Tags from './Tags.vue';
import SloConfigure from '../../algolia/SloConfigure.vue';
import SloIcon from '../../../lib/components/SloIcon.vue';
import SloButton from '../../../lib/components/SloButton.vue';
import SloLoader from '../../../lib/components/SloLoader.vue';
import t from '../../main/i18n';

export default {
  components: {
    Sidebar,
    Tags,
    SloConfigure,
    SloButton,
    SloIcon,
    SloLoader,
    FocusLock
  },
  data() {
    return {
      loading: true,
      productDetailsState: 'loading',
      fromRoute: null,
      isSidebarOpen: true,
      item: null,
      products: []
    };
  },

  filters: {
    t
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$data.fromRoute = from;
    });
  },

  computed: {
    mid() {
      return this.$route.params.id;
    }
  },

  mounted() {
    setTimeout(() => this.loading = false, 100);

    window.addEventListener('resize', () => {
      if (window.innerWidth < 992) {
        this.isSidebarOpen = true;
      }
    });
  },

  watch: {
    item() {
      if (!this.item) return;

      this.fetchProductDetails();
    },

    products() {
      if (!this.products) return [];
      return this.products;
    }
  },

  methods: {
    transformItems(items) {
      this.item = items[0];
      return items;
    },

    fetchProductDetails() {
      this.productDetailsState = 'loading';
      fetch('/rendering-repository/product-details', {
        method: 'POST',
        body: JSON.stringify({ids: this.item.variations})
      })
        .then(response => response.json())
        .then(response => {
          this.productDetailsState = 'success';
          return (this.products = response);
        })
        .catch(() => {
          this.productDetailsState = 'error';
        });
    },

    handleToggle() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },

    handleClose() {
      if (this.fromRoute && this.fromRoute.name === 'search') {
        return this.$router.back();
      } else {
        return this.$router.push({name: 'search'});
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.slide-container {
  z-index: 1030;
  overflow-y: auto;
}

.msie .responsive-image {
  figure > img {
    max-width: 100%;
    height: auto;
    width: auto;
  }
}

.slide {
  width: 100%;

  @media screen and (min-width: 992px) {
    width: calc(100% - 70px);
    padding-bottom: 128px;

    &.open {
      width: 66.66%;
    }
  }
}
</style>
